const realtimeConsultationTranslations = {
  "en-US": {
    "title": "Live consultations",
    "call": "Consultation call",
    "available": "Accepting calls",
    "synced": "Connected",
    "reconnecting": "Reconnecting",
    "refresh": "Refresh",
    "incoming": "Incoming",
    "patients": "Online patients",
    "history": "History",
    "current": "Current call",
    "noIncoming": "No incoming calls",
    "noPatients": "No patients online",
    "noHistory": "No previous calls",
    "patient": "Patient",
    "visit": "Visit {{id}}",
    "invite": "Call patient",
    "noSelection": "Select a call or an online patient",
    "patientChart": "Patient chart",
    "incomingCall": "Patient is calling",
    "waitingPatient": "Waiting for the patient",
    "accept": "Accept",
    "reject": "Decline",
    "cancel": "Cancel",
    "end": "End call",
    "recordingAgreed": "Audio recording authorized",
    "recordingNotAgreed": "Audio recording not authorized",
    "transcript": "Call transcript",
    "noTranscript": "No transcript yet",
    "transcriptHint": "Each line is one recognized speech interval on the call timeline; it may be shorter than the complete recording.",
    "recordings": "Call recording",
    "combined": "Complete call",
    "combinedHint": "Stereo recording: doctor on the left channel, patient on the right channel.",
    "sourceRecordings": "Source recordings",
    "recordingsHint": "This is the complete call recording. Short source chunks may be uploaded in the background to keep capture reliable.",
    "recordingGapHint": "A {{duration}} gap appears between segments from the same source. This usually means the audio connection was interrupted or an older segment finished late; transcript times remain on the call timeline.",
    "recordingMissingSource": "No {{sources}} source audio was captured.",
    "callTime": "Call time",
    "callDuration": "Call duration",
    "durationUnavailable": "Unavailable",
    "segmentTimeUnavailable": "Segment time unavailable",
    "segmentTimeline": "Timeline",
    "segmentDuration": "Duration",
    "summary": "Consultation summary",
    "measurements": "Measurements",
    "noMeasurements": "No measurement capabilities available",
    "startMeasurement": "Start measurement",
    "stopMeasurement": "Stop measurement",
    "handoffNote": "Doctor handoff note",
    "noteRequired": "A doctor note is required before AI can continue when the recording is unavailable or incomplete.",
    "saveNote": "Save note",
    "returnAI": "Return to AI",
    "finishReport": "Finish and prepare report",
    "pendingReview": "The call will be summarized before AI continues or prepares a report. Reports still require doctor review.",
    "unavailable": "Remote consultation service unavailable",
    "loadError": "Unable to load consultation details. Refresh to try again.",
   "actionError": "The action was not completed. Refresh the call status and try again.",
    "audioLoading": "Loading the complete call recording...",
    "audioPlaybackError": "The complete call recording is temporarily unavailable. Try loading it again or use Download.",
    "retryAudio": "Retry playback",
    "audioOnly": "Camera off / audio call",
    "mute": "Mute microphone",
    "unmute": "Unmute microphone",
    "cameraOff": "Turn camera off",
    "cameraOn": "Turn camera on",
    "devices": "Audio and video devices",
    "speakerOn": "Turn off speaker",
    "speakerOff": "Turn on speaker",
    "playAudio": "Play audio",
    "retry": "Reconnect",
    "audioinput": "Microphone",
    "videoinput": "Camera",
    "audiooutput": "Speaker",
    "selectDevice": "Select device",
    "connectionError": "Could not connect to the call. Check the network and reconnect.",
    "secureContextError": "Camera and microphone require HTTPS. Open the doctor workspace over a secure HTTPS address.",
    "microphoneError": "Microphone unavailable. Check browser permissions or select another microphone.",
    "cameraError": "Camera unavailable. The audio call can continue.",
    "deviceError": "Could not switch or play this device.",
    "download": "Download audio",
    "status": {
      "ringing": "Ringing",
      "connecting": "Connecting",
      "active": "In call",
      "reconnecting": "Reconnecting",
      "ended": "Ended",
      "cancelled": "Cancelled",
      "declined": "Declined",
      "missed": "Missed"
    },
    "connection": {
      "connecting": "Connecting",
      "connected": "Connected",
      "reconnecting": "Reconnecting",
      "disconnected": "Disconnected",
      "signalReconnecting": "Reconnecting"
    },
    "processing": {
      "none": "Not started",
      "collecting": "Collecting audio",
      "transcribing": "Transcribing",
      "summarizing": "Summarizing",
      "ready": "Handoff ready",
      "needs_note": "Doctor note required",
      "failed": "Processing failed"
    },
    "source": {
      "doctor": "Doctor",
      "patient_terminal": "Patient"
    },
    "measurementStatus": {
      "pending": "Pending",
      "starting": "Starting",
      "measuring": "Measuring",
      "completed": "Completed",
      "failed": "Failed",
      "cancelled": "Cancelled",
      "stopped": "Stopped",
      "timeout": "Timed out"
    },
    "recordingStatus": {
      "recording": "Recording",
      "ready": "Available",
      "complete": "Available",
      "completed": "Available",
      "failed": "Recording failed"
    }
  },
  "zh-CN": {
    "title": "实时问诊",
    "call": "视频问诊",
    "available": "接受来电",
    "synced": "已连接",
    "reconnecting": "正在重新连接",
    "refresh": "刷新",
    "incoming": "待接来电",
    "patients": "在线患者",
    "history": "历史记录",
    "current": "当前通话",
    "noIncoming": "暂无来电",
    "noPatients": "暂无在线患者",
    "noHistory": "暂无历史通话",
    "patient": "患者",
    "visit": "就诊 {{id}}",
    "invite": "呼叫患者",
    "noSelection": "选择来电或在线患者",
    "patientChart": "患者档案",
    "incomingCall": "患者来电",
    "waitingPatient": "等待患者接听",
    "accept": "接听",
    "reject": "拒绝",
    "cancel": "取消",
    "end": "结束通话",
    "recordingAgreed": "已同意音频录制",
    "recordingNotAgreed": "未同意音频录制",
    "transcript": "通话转录",
    "noTranscript": "暂无转录内容",
    "transcriptHint": "每一行是通话时间轴上的一段识别结果，可能短于整段录音。",
    "recordings": "通话录音",
    "combined": "完整通话",
    "combinedHint": "双声道录音：医生在左声道，患者在右声道。",
    "sourceRecordings": "原始录音",
    "recordingsHint": "这里展示整段通话录音；后台可能按短片段上传，以保证录音稳定。",
    "recordingGapHint": "同一来源的分段之间有 {{duration}} 的时间空档，通常表示录音连接中断或旧分段归档延迟；转录仍按通话时间轴显示。",
    "recordingMissingSource": "未采集到 {{sources}} 的原始录音。",
    "callTime": "通话时间",
    "callDuration": "通话时长",
    "durationUnavailable": "暂无",
    "segmentTimeUnavailable": "暂无分段时间",
    "segmentTimeline": "时间轴",
    "segmentDuration": "时长",
    "summary": "问诊总结",
    "measurements": "测量项目",
    "noMeasurements": "暂无可用测量项目",
    "startMeasurement": "开始测量",
    "stopMeasurement": "停止测量",
    "handoffNote": "医生交接记录",
    "noteRequired": "录音不可用或内容不完整时，需要医生补充交接记录后才能继续 AI 问诊。",
    "saveNote": "保存记录",
    "returnAI": "交回 AI",
    "finishReport": "结束并生成待审核报告",
    "pendingReview": "通话总结完成后，AI 将继续问诊或生成报告；报告仍需医生审核。",
    "unavailable": "远程问诊服务暂不可用",
    "loadError": "无法加载问诊详情，请刷新重试。",
   "actionError": "操作未完成，请刷新通话状态后重试。",
    "audioLoading": "正在加载完整通话录音...",
    "audioPlaybackError": "完整通话录音暂时无法播放，请重新加载或使用下载。",
    "retryAudio": "重试播放",
    "audioOnly": "摄像头关闭 / 音频通话",
    "mute": "关闭麦克风",
    "unmute": "打开麦克风",
    "cameraOff": "关闭摄像头",
    "cameraOn": "打开摄像头",
    "devices": "音视频设备",
    "speakerOn": "关闭扬声器",
    "speakerOff": "打开扬声器",
    "playAudio": "播放音频",
    "retry": "重新连接",
    "audioinput": "麦克风",
    "videoinput": "摄像头",
    "audiooutput": "扬声器",
    "selectDevice": "选择设备",
    "connectionError": "无法连接通话，请检查网络后重试。",
    "secureContextError": "摄像头和麦克风需要 HTTPS，请使用安全的 HTTPS 地址打开医生工作台。",
    "microphoneError": "麦克风不可用，请检查浏览器权限或选择其他麦克风。",
    "cameraError": "摄像头不可用，可以继续音频通话。",
    "deviceError": "无法切换或播放此设备。",
    "download": "下载音频",
    "status": {
      "ringing": "响铃中",
      "connecting": "连接中",
      "active": "通话中",
      "reconnecting": "重连中",
      "ended": "已结束",
      "cancelled": "已取消",
      "declined": "已拒绝",
      "missed": "未接听"
    },
    "connection": {
      "connecting": "连接中",
      "connected": "已连接",
      "reconnecting": "重连中",
      "disconnected": "连接中断",
      "signalReconnecting": "重连中"
    },
    "processing": {
      "none": "尚未开始",
      "collecting": "整理录音中",
      "transcribing": "转录中",
      "summarizing": "总结中",
      "ready": "交接就绪",
      "needs_note": "需要医生补记",
      "failed": "处理失败"
    },
    "source": {
      "doctor": "医生",
      "patient_terminal": "患者"
    },
    "measurementStatus": {
      "pending": "等待测量",
      "starting": "正在启动",
      "measuring": "测量中",
      "completed": "已完成",
      "failed": "失败",
      "cancelled": "已取消",
      "stopped": "已停止",
      "timeout": "已超时"
    },
    "recordingStatus": {
      "recording": "录制中",
      "ready": "可播放",
      "complete": "可播放",
      "completed": "可播放",
      "failed": "录音失败"
    }
  },
  "zh-TW": {
    "title": "即時問診",
    "call": "視訊問診",
    "available": "接受來電",
    "synced": "已連線",
    "reconnecting": "正在重新連線",
    "refresh": "重新整理",
    "incoming": "待接來電",
    "patients": "線上患者",
    "history": "歷史紀錄",
    "current": "目前通話",
    "noIncoming": "暫無來電",
    "noPatients": "暫無線上患者",
    "noHistory": "暫無歷史通話",
    "patient": "患者",
    "visit": "就診 {{id}}",
    "invite": "呼叫患者",
    "noSelection": "選擇來電或線上患者",
    "patientChart": "患者檔案",
    "incomingCall": "患者來電",
    "waitingPatient": "等待患者接聽",
    "accept": "接聽",
    "reject": "拒絕",
    "cancel": "取消",
    "end": "結束通話",
    "recordingAgreed": "已同意音訊錄製",
    "recordingNotAgreed": "未同意音訊錄製",
    "transcript": "通話轉錄",
    "noTranscript": "暫無轉錄內容",
    "transcriptHint": "每一行是通話時間軸上的一段辨識結果，可能短於完整錄音。",
    "recordings": "通話錄音",
    "combined": "完整通話",
    "combinedHint": "雙聲道錄音：醫生在左聲道，患者在右聲道。",
    "sourceRecordings": "原始錄音",
    "recordingsHint": "這裡顯示完整通話錄音；背景可能按短片段上載，以確保錄音穩定。",
    "recordingGapHint": "同一來源的分段之間有 {{duration}} 的時間空檔，通常表示錄音連線中斷或舊分段歸檔延遲；轉錄仍按通話時間軸顯示。",
    "recordingMissingSource": "未採集到 {{sources}} 的原始錄音。",
    "callTime": "通話時間",
    "callDuration": "通話時長",
    "durationUnavailable": "暫無",
    "segmentTimeUnavailable": "暫無分段時間",
    "segmentTimeline": "時間軸",
    "segmentDuration": "時長",
    "summary": "問診摘要",
    "measurements": "測量項目",
    "noMeasurements": "暫無可用測量項目",
    "startMeasurement": "開始測量",
    "stopMeasurement": "停止測量",
    "handoffNote": "醫師交接紀錄",
    "noteRequired": "錄音無法使用或內容不完整時，需要醫師補充交接紀錄後才能繼續 AI 問診。",
    "saveNote": "儲存紀錄",
    "returnAI": "交回 AI",
    "finishReport": "結束並產生待審核報告",
    "pendingReview": "通話摘要完成後，AI 將繼續問診或產生報告；報告仍需醫師審核。",
    "unavailable": "遠端問診服務暫時無法使用",
    "loadError": "無法載入問診詳情，請重新整理後重試。",
   "actionError": "操作未完成，請重新整理通話狀態後重試。",
    "audioLoading": "正在載入完整通話錄音...",
    "audioPlaybackError": "完整通話錄音暫時無法播放，請重新載入或使用下載。",
    "retryAudio": "重試播放",
    "audioOnly": "攝影機關閉 / 音訊通話",
    "mute": "關閉麥克風",
    "unmute": "開啟麥克風",
    "cameraOff": "關閉攝影機",
    "cameraOn": "開啟攝影機",
    "devices": "音訊與視訊設備",
    "speakerOn": "關閉揚聲器",
    "speakerOff": "開啟揚聲器",
    "playAudio": "播放音訊",
    "retry": "重新連線",
    "audioinput": "麥克風",
    "videoinput": "攝影機",
    "audiooutput": "喇叭",
    "selectDevice": "選擇設備",
    "connectionError": "無法連線通話，請檢查網路後重試。",
    "secureContextError": "摄像头和麦克风需要 HTTPS，请使用安全的 HTTPS 地址打开医生工作台。",
    "microphoneError": "麥克風無法使用，請檢查瀏覽器權限或選擇其他麥克風。",
    "cameraError": "攝影機無法使用，可以繼續音訊通話。",
    "deviceError": "無法切換或播放此設備。",
    "download": "下載音訊",
    "status": {
      "ringing": "響鈴中",
      "connecting": "連線中",
      "active": "通話中",
      "reconnecting": "重新連線中",
      "ended": "已結束",
      "cancelled": "已取消",
      "declined": "已拒絕",
      "missed": "未接聽"
    },
    "connection": {
      "connecting": "連線中",
      "connected": "已連線",
      "reconnecting": "重新連線中",
      "disconnected": "連線中斷",
      "signalReconnecting": "重新連線中"
    },
    "processing": {
      "none": "尚未開始",
      "collecting": "整理錄音中",
      "transcribing": "轉錄中",
      "summarizing": "摘要處理中",
      "ready": "交接就緒",
      "needs_note": "需要醫師補記",
      "failed": "處理失敗"
    },
    "source": {
      "doctor": "醫師",
      "patient_terminal": "患者"
    },
    "measurementStatus": {
      "pending": "等待測量",
      "starting": "正在啟動",
      "measuring": "測量中",
      "completed": "已完成",
      "failed": "失敗",
      "cancelled": "已取消",
      "stopped": "已停止",
      "timeout": "已逾時"
    },
    "recordingStatus": {
      "recording": "錄製中",
      "ready": "可播放",
      "complete": "可播放",
      "completed": "可播放",
      "failed": "錄音失敗"
    }
  },
  "ar-SA": {
    "title": "الاستشارات المباشرة",
    "call": "مكالمة الاستشارة",
    "available": "استقبال المكالمات",
    "synced": "متصل",
    "reconnecting": "إعادة الاتصال",
    "refresh": "تحديث",
    "incoming": "المكالمات الواردة",
    "patients": "المرضى المتصلون",
    "history": "السجل",
    "current": "المكالمة الحالية",
    "noIncoming": "لا توجد مكالمات واردة",
    "noPatients": "لا يوجد مرضى متصلون",
    "noHistory": "لا توجد مكالمات سابقة",
    "patient": "المريض",
    "visit": "الزيارة {{id}}",
    "invite": "الاتصال بالمريض",
    "noSelection": "اختر مكالمة أو مريضاً متصلاً",
    "patientChart": "ملف المريض",
    "incomingCall": "مكالمة من المريض",
    "waitingPatient": "بانتظار رد المريض",
    "accept": "قبول",
    "reject": "رفض",
    "cancel": "إلغاء",
    "end": "إنهاء المكالمة",
    "recordingAgreed": "تمت الموافقة على التسجيل الصوتي",
    "recordingNotAgreed": "لم تتم الموافقة على التسجيل الصوتي",
    "transcript": "نص المكالمة",
    "noTranscript": "لا يوجد نص بعد",
    "transcriptHint": "كل سطر هو فترة كلام متعرّف عليها على خط زمن المكالمة، وقد تكون أقصر من التسجيل الكامل.",
    "recordings": "تسجيل المكالمة",
    "combined": "المكالمة الكاملة",
    "combinedHint": "تسجيل استريو: الطبيب في القناة اليسرى والمريض في القناة اليمنى.",
    "sourceRecordings": "التسجيلات الأصلية",
    "recordingsHint": "يُعرض هنا تسجيل المكالمة كاملاً؛ وقد تُرفع مقاطع قصيرة في الخلفية لضمان ثبات الالتقاط.",
    "recordingGapHint": "توجد فجوة مدتها {{duration}} بين مقاطع المصدر نفسه. يشير ذلك عادةً إلى انقطاع اتصال الصوت أو تأخر إنهاء مقطع أقدم؛ وتبقى أوقات النص على خط زمن المكالمة.",
    "recordingMissingSource": "لم يُلتقط تسجيل أصلي من {{sources}}.",
    "callTime": "وقت المكالمة",
    "callDuration": "مدة المكالمة",
    "durationUnavailable": "غير متاح",
    "segmentTimeUnavailable": "وقت المقطع غير متاح",
    "segmentTimeline": "الخط الزمني",
    "segmentDuration": "المدة",
    "summary": "ملخص الاستشارة",
    "measurements": "القياسات",
    "noMeasurements": "لا توجد قياسات متاحة",
    "startMeasurement": "بدء القياس",
    "stopMeasurement": "إيقاف القياس",
    "handoffNote": "ملاحظات التسليم من الطبيب",
    "noteRequired": "يلزم تدوين ملاحظات الطبيب قبل متابعة الذكاء الاصطناعي إذا كان التسجيل غير متاح أو غير مكتمل.",
    "saveNote": "حفظ الملاحظات",
    "returnAI": "العودة إلى الذكاء الاصطناعي",
    "finishReport": "إنهاء وإعداد التقرير",
    "pendingReview": "سيتم تلخيص المكالمة قبل متابعة الذكاء الاصطناعي أو إعداد التقرير. تظل مراجعة الطبيب مطلوبة.",
    "unavailable": "خدمة الاستشارة عن بعد غير متاحة",
    "loadError": "تعذر تحميل تفاصيل الاستشارة. حدّث الصفحة وحاول مجدداً.",
   "actionError": "لم تكتمل العملية. حدّث حالة المكالمة وحاول مجدداً.",
    "audioLoading": "جارٍ تحميل تسجيل المكالمة الكامل...",
    "audioPlaybackError": "يتعذر تشغيل تسجيل المكالمة الكامل مؤقتًا. حاول التحميل مرة أخرى أو استخدم التنزيل.",
    "retryAudio": "إعادة التشغيل",
    "audioOnly": "الكاميرا متوقفة / مكالمة صوتية",
    "mute": "كتم الميكروفون",
    "unmute": "تشغيل الميكروفون",
    "cameraOff": "إيقاف الكاميرا",
    "cameraOn": "تشغيل الكاميرا",
    "devices": "أجهزة الصوت والفيديو",
    "speakerOn": "إيقاف مكبر الصوت",
    "speakerOff": "تشغيل مكبر الصوت",
    "playAudio": "تشغيل الصوت",
    "retry": "إعادة الاتصال",
    "audioinput": "الميكروفون",
    "videoinput": "الكاميرا",
    "audiooutput": "مكبر الصوت",
    "selectDevice": "اختيار الجهاز",
    "connectionError": "تعذر الاتصال بالمكالمة. تحقق من الشبكة وأعد المحاولة.",
    "secureContextError": "Camera and microphone require HTTPS. Open the doctor workspace over a secure HTTPS address.",
    "microphoneError": "الميكروفون غير متاح. تحقق من أذونات المتصفح أو اختر ميكروفوناً آخر.",
    "cameraError": "الكاميرا غير متاحة. يمكن متابعة المكالمة الصوتية.",
    "deviceError": "تعذر تبديل هذا الجهاز أو تشغيله.",
    "download": "تنزيل الصوت",
    "status": {
      "ringing": "يرن",
      "connecting": "جار الاتصال",
      "active": "في مكالمة",
      "reconnecting": "إعادة الاتصال",
      "ended": "انتهت",
      "cancelled": "ملغاة",
      "declined": "مرفوضة",
      "missed": "لم يتم الرد"
    },
    "connection": {
      "connecting": "جار الاتصال",
      "connected": "متصل",
      "reconnecting": "إعادة الاتصال",
      "disconnected": "غير متصل",
      "signalReconnecting": "إعادة الاتصال"
    },
    "processing": {
      "none": "لم يبدأ",
      "collecting": "تجميع الصوت",
      "transcribing": "تحويل الصوت إلى نص",
      "summarizing": "إعداد الملخص",
      "ready": "جاهز للتسليم",
      "needs_note": "ملاحظات الطبيب مطلوبة",
      "failed": "فشلت المعالجة"
    },
    "source": {
      "doctor": "طرف الطبيب",
      "patient_terminal": "طرف المريض"
    },
    "measurementStatus": {
      "pending": "قيد الانتظار",
      "starting": "جار البدء",
      "measuring": "جار القياس",
      "completed": "مكتمل",
      "failed": "فشل",
      "cancelled": "ملغى",
      "stopped": "متوقف",
      "timeout": "انتهت المهلة"
    },
    "recordingStatus": {
      "recording": "جار التسجيل",
      "ready": "متاح",
      "complete": "متاح",
      "completed": "متاح",
      "failed": "فشل التسجيل"
    }
  },
  "vi-VN": {
    "title": "Khám trực tuyến",
    "call": "Cuộc gọi khám bệnh",
    "available": "Nhận cuộc gọi",
    "synced": "Đã kết nối",
    "reconnecting": "Đang kết nối lại",
    "refresh": "Làm mới",
    "incoming": "Cuộc gọi đến",
    "patients": "Bệnh nhân trực tuyến",
    "history": "Lịch sử",
    "current": "Cuộc gọi hiện tại",
    "noIncoming": "Không có cuộc gọi đến",
    "noPatients": "Không có bệnh nhân trực tuyến",
    "noHistory": "Chưa có cuộc gọi trước",
    "patient": "Bệnh nhân",
    "visit": "Lượt khám {{id}}",
    "invite": "Gọi bệnh nhân",
    "noSelection": "Chọn cuộc gọi hoặc bệnh nhân trực tuyến",
    "patientChart": "Hồ sơ bệnh nhân",
    "incomingCall": "Bệnh nhân đang gọi",
    "waitingPatient": "Đang chờ bệnh nhân trả lời",
    "accept": "Tiếp nhận",
    "reject": "Từ chối",
    "cancel": "Hủy",
    "end": "Kết thúc cuộc gọi",
    "recordingAgreed": "Đã đồng ý ghi âm",
    "recordingNotAgreed": "Chưa đồng ý ghi âm",
    "transcript": "Bản chép cuộc gọi",
    "noTranscript": "Chưa có bản chép",
    "transcriptHint": "Mỗi dòng là một khoảng lời nói được nhận dạng trên dòng thời gian cuộc gọi và có thể ngắn hơn bản ghi đầy đủ.",
    "recordings": "Bản ghi cuộc gọi",
    "combined": "Cuộc gọi đầy đủ",
    "combinedHint": "Bản ghi âm stereo: bác sĩ ở kênh trái, bệnh nhân ở kênh phải.",
    "sourceRecordings": "Bản ghi nguồn",
    "recordingsHint": "Đây là bản ghi đầy đủ của cuộc gọi. Các đoạn nguồn ngắn có thể được tải lên nền để việc thu âm ổn định hơn.",
    "recordingGapHint": "Có khoảng trống {{duration}} giữa các đoạn của cùng một nguồn. Thường là do kết nối âm thanh bị gián đoạn hoặc đoạn cũ hoàn tất muộn; thời gian chép lời vẫn theo dòng thời gian cuộc gọi.",
    "recordingMissingSource": "Không ghi nhận bản âm thanh nguồn từ {{sources}}.",
    "callTime": "Thời gian cuộc gọi",
    "callDuration": "Thời lượng cuộc gọi",
    "durationUnavailable": "Không có",
    "segmentTimeUnavailable": "Không có thời gian đoạn âm thanh",
    "segmentTimeline": "Dòng thời gian",
    "segmentDuration": "Thời lượng",
    "summary": "Tóm tắt khám bệnh",
    "measurements": "Các phép đo",
    "noMeasurements": "Không có phép đo khả dụng",
    "startMeasurement": "Bắt đầu đo",
    "stopMeasurement": "Dừng đo",
    "handoffNote": "Ghi chú bàn giao của bác sĩ",
    "noteRequired": "Cần ghi chú của bác sĩ trước khi AI tiếp tục nếu bản ghi âm không có hoặc không đầy đủ.",
    "saveNote": "Lưu ghi chú",
    "returnAI": "Trả lại cho AI",
    "finishReport": "Kết thúc và tạo báo cáo chờ duyệt",
    "pendingReview": "Cuộc gọi sẽ được tóm tắt trước khi AI tiếp tục hoặc tạo báo cáo. Báo cáo vẫn cần bác sĩ duyệt.",
    "unavailable": "Dịch vụ khám từ xa chưa khả dụng",
    "loadError": "Không thể tải chi tiết khám. Vui lòng làm mới và thử lại.",
   "actionError": "Thao tác chưa hoàn tất. Làm mới trạng thái cuộc gọi và thử lại.",
    "audioLoading": "Đang tải bản ghi cuộc gọi đầy đủ...",
    "audioPlaybackError": "Bản ghi cuộc gọi đầy đủ hiện không thể phát. Hãy tải lại hoặc dùng nút Tải xuống.",
    "retryAudio": "Thử phát lại",
    "audioOnly": "Tắt camera / cuộc gọi âm thanh",
    "mute": "Tắt micrô",
    "unmute": "Bật micrô",
    "cameraOff": "Tắt camera",
    "cameraOn": "Bật camera",
    "devices": "Thiết bị âm thanh và hình ảnh",
    "speakerOn": "Tắt loa",
    "speakerOff": "Bật loa",
    "playAudio": "Phát âm thanh",
    "retry": "Kết nối lại",
    "audioinput": "Micrô",
    "videoinput": "Camera",
    "audiooutput": "Loa",
    "selectDevice": "Chọn thiết bị",
    "connectionError": "Không thể kết nối cuộc gọi. Kiểm tra mạng và thử lại.",
    "secureContextError": "Camera and microphone require HTTPS. Open the doctor workspace over a secure HTTPS address.",
    "microphoneError": "Micrô không khả dụng. Kiểm tra quyền trình duyệt hoặc chọn micrô khác.",
    "cameraError": "Camera không khả dụng. Có thể tiếp tục cuộc gọi âm thanh.",
    "deviceError": "Không thể chuyển hoặc phát thiết bị này.",
    "download": "Tải âm thanh",
    "status": {
      "ringing": "Đang đổ chuông",
      "connecting": "Đang kết nối",
      "active": "Đang gọi",
      "reconnecting": "Đang kết nối lại",
      "ended": "Đã kết thúc",
      "cancelled": "Đã hủy",
      "declined": "Đã từ chối",
      "missed": "Không trả lời"
    },
    "connection": {
      "connecting": "Đang kết nối",
      "connected": "Đã kết nối",
      "reconnecting": "Đang kết nối lại",
      "disconnected": "Mất kết nối",
      "signalReconnecting": "Đang kết nối lại"
    },
    "processing": {
      "none": "Chưa bắt đầu",
      "collecting": "Đang thu thập âm thanh",
      "transcribing": "Đang chép lời",
      "summarizing": "Đang tóm tắt",
      "ready": "Sẵn sàng bàn giao",
      "needs_note": "Cần ghi chú bác sĩ",
      "failed": "Xử lý thất bại"
    },
    "source": {
      "doctor": "Đầu bác sĩ",
      "patient_terminal": "Đầu bệnh nhân"
    },
    "measurementStatus": {
      "pending": "Đang chờ",
      "starting": "Đang bắt đầu",
      "measuring": "Đang đo",
      "completed": "Đã hoàn tất",
      "failed": "Thất bại",
      "cancelled": "Đã hủy",
      "stopped": "Đã dừng",
      "timeout": "Hết thời gian"
    },
    "recordingStatus": {
      "recording": "Đang ghi âm",
      "ready": "Có thể phát",
      "complete": "Có thể phát",
      "completed": "Có thể phát",
      "failed": "Ghi âm thất bại"
    }
  },
  "th-TH": {
    "title": "ปรึกษาแพทย์แบบเรียลไทม์",
    "call": "สายปรึกษาแพทย์",
    "available": "รับสาย",
    "synced": "เชื่อมต่อแล้ว",
    "reconnecting": "กำลังเชื่อมต่อใหม่",
    "refresh": "รีเฟรช",
    "incoming": "สายเรียกเข้า",
    "patients": "ผู้ป่วยออนไลน์",
    "history": "ประวัติ",
    "current": "สายปัจจุบัน",
    "noIncoming": "ไม่มีสายเรียกเข้า",
    "noPatients": "ไม่มีผู้ป่วยออนไลน์",
    "noHistory": "ยังไม่มีประวัติการโทร",
    "patient": "ผู้ป่วย",
    "visit": "การตรวจ {{id}}",
    "invite": "โทรหาผู้ป่วย",
    "noSelection": "เลือกสายหรือผู้ป่วยออนไลน์",
    "patientChart": "ประวัติผู้ป่วย",
    "incomingCall": "ผู้ป่วยกำลังโทร",
    "waitingPatient": "รอผู้ป่วยรับสาย",
    "accept": "รับสาย",
    "reject": "ปฏิเสธ",
    "cancel": "ยกเลิก",
    "end": "จบการโทร",
    "recordingAgreed": "อนุญาตให้บันทึกเสียงแล้ว",
    "recordingNotAgreed": "ยังไม่อนุญาตให้บันทึกเสียง",
    "transcript": "ข้อความถอดเสียง",
    "noTranscript": "ยังไม่มีข้อความถอดเสียง",
    "transcriptHint": "แต่ละบรรทัดคือช่วงคำพูดที่รู้จำได้บนไทม์ไลน์การโทร และอาจสั้นกว่าเสียงบันทึกฉบับเต็ม",
    "recordings": "บันทึกการโทร",
    "combined": "การสนทนาฉบับเต็ม",
    "combinedHint": "เสียงสเตอริโอ: แพทย์อยู่ช่องซ้าย ผู้ป่วยอยู่ช่องขวา",
    "sourceRecordings": "ไฟล์บันทึกต้นฉบับ",
    "recordingsHint": "ส่วนนี้แสดงเสียงบันทึกการโทรฉบับเต็ม ระบบอาจอัปโหลดช่วงเสียงสั้น ๆ เบื้องหลังเพื่อให้การบันทึกเสถียร",
    "recordingGapHint": "พบช่วงว่าง {{duration}} ระหว่างช่วงเสียงจากแหล่งเดียวกัน โดยทั่วไปหมายถึงการเชื่อมต่อเสียงขาดช่วงหรือช่วงก่อนหน้าเสร็จช้า ข้อความถอดเสียงยังใช้ไทม์ไลน์การโทร",
    "recordingMissingSource": "ไม่พบไฟล์บันทึกต้นฉบับจาก {{sources}}",
    "callTime": "เวลาสาย",
    "callDuration": "ระยะเวลาสาย",
    "durationUnavailable": "ไม่พร้อมใช้งาน",
    "segmentTimeUnavailable": "ไม่มีเวลาช่วงเสียง",
    "segmentTimeline": "ไทม์ไลน์",
    "segmentDuration": "ระยะเวลา",
    "summary": "สรุปการปรึกษา",
    "measurements": "รายการวัด",
    "noMeasurements": "ไม่มีรายการวัดที่พร้อมใช้งาน",
    "startMeasurement": "เริ่มวัด",
    "stopMeasurement": "หยุดวัด",
    "handoffNote": "บันทึกส่งต่อของแพทย์",
    "noteRequired": "ต้องมีบันทึกของแพทย์ก่อนที่ AI จะดำเนินการต่อ หากไม่มีเสียงบันทึกหรือเสียงไม่สมบูรณ์",
    "saveNote": "บันทึก",
    "returnAI": "ส่งกลับให้ AI",
    "finishReport": "จบและสร้างรายงานรอตรวจสอบ",
    "pendingReview": "ระบบจะสรุปการโทรก่อนที่ AI จะดำเนินการต่อหรือสร้างรายงาน รายงานยังต้องได้รับการตรวจสอบโดยแพทย์",
    "unavailable": "บริการปรึกษาทางไกลไม่พร้อมใช้งาน",
    "loadError": "โหลดรายละเอียดการปรึกษาไม่ได้ โปรดรีเฟรชและลองอีกครั้ง",
   "actionError": "ดำเนินการไม่สำเร็จ โปรดรีเฟรชสถานะสายแล้วลองอีกครั้ง",
    "audioLoading": "กำลังโหลดบันทึกการโทรฉบับเต็ม...",
    "audioPlaybackError": "ขณะนี้ไม่สามารถเล่นบันทึกการโทรฉบับเต็มได้ ลองโหลดใหม่อีกครั้งหรือใช้ปุ่มดาวน์โหลด",
    "retryAudio": "ลองเล่นอีกครั้ง",
    "audioOnly": "กล้องปิด / โทรด้วยเสียง",
    "mute": "ปิดไมโครโฟน",
    "unmute": "เปิดไมโครโฟน",
    "cameraOff": "ปิดกล้อง",
    "cameraOn": "เปิดกล้อง",
    "devices": "อุปกรณ์เสียงและวิดีโอ",
    "speakerOn": "ปิดลำโพง",
    "speakerOff": "เปิดลำโพง",
    "playAudio": "เล่นเสียง",
    "retry": "เชื่อมต่อใหม่",
    "audioinput": "ไมโครโฟน",
    "videoinput": "กล้อง",
    "audiooutput": "ลำโพง",
    "selectDevice": "เลือกอุปกรณ์",
    "connectionError": "เชื่อมต่อสายไม่ได้ โปรดตรวจสอบเครือข่ายและลองอีกครั้ง",
    "secureContextError": "Camera and microphone require HTTPS. Open the doctor workspace over a secure HTTPS address.",
    "microphoneError": "ไมโครโฟนไม่พร้อมใช้งาน โปรดตรวจสอบสิทธิ์เบราว์เซอร์หรือเลือกไมโครโฟนอื่น",
    "cameraError": "กล้องไม่พร้อมใช้งาน สามารถโทรด้วยเสียงต่อได้",
    "deviceError": "สลับหรือเล่นอุปกรณ์นี้ไม่ได้",
    "download": "ดาวน์โหลดเสียง",
    "status": {
      "ringing": "กำลังเรียก",
      "connecting": "กำลังเชื่อมต่อ",
      "active": "กำลังสนทนา",
      "reconnecting": "กำลังเชื่อมต่อใหม่",
      "ended": "สิ้นสุดแล้ว",
      "cancelled": "ยกเลิกแล้ว",
      "declined": "ปฏิเสธแล้ว",
      "missed": "ไม่ได้รับสาย"
    },
    "connection": {
      "connecting": "กำลังเชื่อมต่อ",
      "connected": "เชื่อมต่อแล้ว",
      "reconnecting": "กำลังเชื่อมต่อใหม่",
      "disconnected": "ขาดการเชื่อมต่อ",
      "signalReconnecting": "กำลังเชื่อมต่อใหม่"
    },
    "processing": {
      "none": "ยังไม่เริ่ม",
      "collecting": "กำลังรวบรวมเสียง",
      "transcribing": "กำลังถอดเสียง",
      "summarizing": "กำลังสรุป",
      "ready": "พร้อมส่งต่อ",
      "needs_note": "ต้องมีบันทึกแพทย์",
      "failed": "ประมวลผลล้มเหลว"
    },
    "source": {
      "doctor": "ฝั่งแพทย์",
      "patient_terminal": "ฝั่งผู้ป่วย"
    },
    "measurementStatus": {
      "pending": "รอดำเนินการ",
      "starting": "กำลังเริ่ม",
      "measuring": "กำลังวัด",
      "completed": "เสร็จแล้ว",
      "failed": "ล้มเหลว",
      "cancelled": "ยกเลิกแล้ว",
      "stopped": "หยุดแล้ว",
      "timeout": "หมดเวลา"
    },
    "recordingStatus": {
      "recording": "กำลังบันทึก",
      "ready": "พร้อมเล่น",
      "complete": "พร้อมเล่น",
      "completed": "พร้อมเล่น",
      "failed": "บันทึกล้มเหลว"
    }
  },
  "id-ID": {
    "title": "Konsultasi langsung",
    "call": "Panggilan konsultasi",
    "available": "Menerima panggilan",
    "synced": "Terhubung",
    "reconnecting": "Menghubungkan kembali",
    "refresh": "Muat ulang",
    "incoming": "Panggilan masuk",
    "patients": "Pasien daring",
    "history": "Riwayat",
    "current": "Panggilan saat ini",
    "noIncoming": "Tidak ada panggilan masuk",
    "noPatients": "Tidak ada pasien daring",
    "noHistory": "Belum ada riwayat panggilan",
    "patient": "Pasien",
    "visit": "Kunjungan {{id}}",
    "invite": "Hubungi pasien",
    "noSelection": "Pilih panggilan atau pasien daring",
    "patientChart": "Rekam medis pasien",
    "incomingCall": "Pasien menelepon",
    "waitingPatient": "Menunggu pasien menjawab",
    "accept": "Terima",
    "reject": "Tolak",
    "cancel": "Batal",
    "end": "Akhiri panggilan",
    "recordingAgreed": "Perekaman audio disetujui",
    "recordingNotAgreed": "Perekaman audio belum disetujui",
    "transcript": "Transkrip panggilan",
    "noTranscript": "Belum ada transkrip",
    "transcriptHint": "Setiap baris adalah interval ucapan yang dikenali pada garis waktu panggilan dan dapat lebih pendek daripada rekaman lengkap.",
    "recordings": "Rekaman panggilan",
    "combined": "Panggilan lengkap",
    "combinedHint": "Rakaman stereo: doktor di saluran kiri, pesakit di saluran kanan.",
    "sourceRecordings": "Rekaman sumber",
    "recordingsHint": "Bagian ini menampilkan rekaman panggilan lengkap. Potongan sumber singkat dapat diunggah di latar belakang agar perekaman tetap andal.",
    "recordingGapHint": "Ada jeda {{duration}} di antara segmen dari sumber yang sama. Biasanya ini berarti koneksi audio terputus atau segmen sebelumnya selesai terlambat; waktu transkrip tetap mengikuti garis waktu panggilan.",
    "recordingMissingSource": "Tidak ada rekaman sumber yang diterima dari {{sources}}.",
    "callTime": "Waktu panggilan",
    "callDuration": "Durasi panggilan",
    "durationUnavailable": "Tidak tersedia",
    "segmentTimeUnavailable": "Waktu segmen tidak tersedia",
    "segmentTimeline": "Garis waktu",
    "segmentDuration": "Durasi",
    "summary": "Ringkasan konsultasi",
    "measurements": "Pengukuran",
    "noMeasurements": "Tidak ada pengukuran tersedia",
    "startMeasurement": "Mulai pengukuran",
    "stopMeasurement": "Hentikan pengukuran",
    "handoffNote": "Catatan serah terima dokter",
    "noteRequired": "Catatan dokter diperlukan sebelum AI melanjutkan jika rekaman tidak tersedia atau tidak lengkap.",
    "saveNote": "Simpan catatan",
    "returnAI": "Kembalikan ke AI",
    "finishReport": "Akhiri dan siapkan laporan",
    "pendingReview": "Panggilan akan diringkas sebelum AI melanjutkan atau menyiapkan laporan. Laporan tetap memerlukan tinjauan dokter.",
    "unavailable": "Layanan konsultasi jarak jauh tidak tersedia",
    "loadError": "Gagal memuat detail konsultasi. Muat ulang dan coba lagi.",
   "actionError": "Tindakan belum selesai. Muat ulang status panggilan dan coba lagi.",
    "audioLoading": "Memuat rekaman panggilan lengkap...",
    "audioPlaybackError": "Rekaman panggilan lengkap sementara tidak dapat diputar. Coba muat ulang atau gunakan Unduh.",
    "retryAudio": "Coba putar lagi",
    "audioOnly": "Kamera mati / panggilan audio",
    "mute": "Bisukan mikrofon",
    "unmute": "Aktifkan mikrofon",
    "cameraOff": "Matikan kamera",
    "cameraOn": "Aktifkan kamera",
    "devices": "Perangkat audio dan video",
    "speakerOn": "Matikan speaker",
    "speakerOff": "Nyalakan speaker",
    "playAudio": "Putar audio",
    "retry": "Hubungkan kembali",
    "audioinput": "Mikrofon",
    "videoinput": "Kamera",
    "audiooutput": "Pengeras suara",
    "selectDevice": "Pilih perangkat",
    "connectionError": "Gagal menghubungkan panggilan. Periksa jaringan dan coba lagi.",
    "secureContextError": "Camera and microphone require HTTPS. Open the doctor workspace over a secure HTTPS address.",
    "microphoneError": "Mikrofon tidak tersedia. Periksa izin peramban atau pilih mikrofon lain.",
    "cameraError": "Kamera tidak tersedia. Panggilan audio dapat dilanjutkan.",
    "deviceError": "Gagal mengganti atau memutar perangkat ini.",
    "download": "Unduh audio",
    "status": {
      "ringing": "Berdering",
      "connecting": "Menghubungkan",
      "active": "Dalam panggilan",
      "reconnecting": "Menghubungkan kembali",
      "ended": "Berakhir",
      "cancelled": "Dibatalkan",
      "declined": "Ditolak",
      "missed": "Tidak terjawab"
    },
    "connection": {
      "connecting": "Menghubungkan",
      "connected": "Terhubung",
      "reconnecting": "Menghubungkan kembali",
      "disconnected": "Terputus",
      "signalReconnecting": "Menghubungkan kembali"
    },
    "processing": {
      "none": "Belum dimulai",
      "collecting": "Mengumpulkan audio",
      "transcribing": "Mentranskripsikan",
      "summarizing": "Meringkas",
      "ready": "Siap diserahkan",
      "needs_note": "Catatan dokter diperlukan",
      "failed": "Pemrosesan gagal"
    },
    "source": {
      "doctor": "Sisi dokter",
      "patient_terminal": "Sisi pasien"
    },
    "measurementStatus": {
      "pending": "Menunggu",
      "starting": "Memulai",
      "measuring": "Mengukur",
      "completed": "Selesai",
      "failed": "Gagal",
      "cancelled": "Dibatalkan",
      "stopped": "Dihentikan",
      "timeout": "Waktu habis"
    },
    "recordingStatus": {
      "recording": "Merekam",
      "ready": "Tersedia",
      "complete": "Tersedia",
      "completed": "Tersedia",
      "failed": "Perekaman gagal"
    }
  },
  "ms-MY": {
    "title": "Konsultasi langsung",
    "call": "Panggilan konsultasi",
    "available": "Menerima panggilan",
    "synced": "Disambungkan",
    "reconnecting": "Menyambung semula",
    "refresh": "Muat semula",
    "incoming": "Panggilan masuk",
    "patients": "Pesakit dalam talian",
    "history": "Sejarah",
    "current": "Panggilan semasa",
    "noIncoming": "Tiada panggilan masuk",
    "noPatients": "Tiada pesakit dalam talian",
    "noHistory": "Tiada panggilan terdahulu",
    "patient": "Pesakit",
    "visit": "Lawatan {{id}}",
    "invite": "Hubungi pesakit",
    "noSelection": "Pilih panggilan atau pesakit dalam talian",
    "patientChart": "Rekod pesakit",
    "incomingCall": "Pesakit sedang menelefon",
    "waitingPatient": "Menunggu pesakit menjawab",
    "accept": "Terima",
    "reject": "Tolak",
    "cancel": "Batal",
    "end": "Tamatkan panggilan",
    "recordingAgreed": "Rakaman audio dipersetujui",
    "recordingNotAgreed": "Rakaman audio belum dipersetujui",
    "transcript": "Transkrip panggilan",
    "noTranscript": "Belum ada transkrip",
    "transcriptHint": "Setiap baris ialah sela pertuturan yang dikenal pasti pada garis masa panggilan dan mungkin lebih pendek daripada rakaman penuh.",
    "recordings": "Rakaman panggilan",
    "combined": "Panggilan penuh",
    "combinedHint": "Rakaman stereo: doktor di saluran kiri, pesakit di saluran kanan.",
    "sourceRecordings": "Rakaman sumber",
    "recordingsHint": "Bahagian ini memaparkan rakaman penuh panggilan. Potongan sumber yang pendek mungkin dimuat naik di latar belakang supaya rakaman kekal stabil.",
    "recordingGapHint": "Terdapat jurang {{duration}} antara segmen daripada sumber yang sama. Biasanya ini bermakna sambungan audio terputus atau segmen lama selesai lewat; masa transkrip kekal pada garis masa panggilan.",
    "recordingMissingSource": "Tiada rakaman sumber diterima daripada {{sources}}.",
    "callTime": "Masa panggilan",
    "callDuration": "Tempoh panggilan",
    "durationUnavailable": "Tidak tersedia",
    "segmentTimeUnavailable": "Masa segmen tidak tersedia",
    "segmentTimeline": "Garis masa",
    "segmentDuration": "Tempoh",
    "summary": "Ringkasan konsultasi",
    "measurements": "Pengukuran",
    "noMeasurements": "Tiada pengukuran tersedia",
    "startMeasurement": "Mulakan pengukuran",
    "stopMeasurement": "Hentikan pengukuran",
    "handoffNote": "Nota serahan doktor",
    "noteRequired": "Nota doktor diperlukan sebelum AI meneruskan jika rakaman tiada atau tidak lengkap.",
    "saveNote": "Simpan nota",
    "returnAI": "Kembalikan kepada AI",
    "finishReport": "Tamatkan dan sediakan laporan",
    "pendingReview": "Panggilan akan diringkaskan sebelum AI meneruskan atau menyediakan laporan. Laporan masih memerlukan semakan doktor.",
    "unavailable": "Perkhidmatan konsultasi jarak jauh tidak tersedia",
    "loadError": "Butiran konsultasi gagal dimuatkan. Muat semula dan cuba lagi.",
   "actionError": "Tindakan belum selesai. Muat semula status panggilan dan cuba lagi.",
    "audioLoading": "Memuat rakaman panggilan penuh...",
    "audioPlaybackError": "Rakaman panggilan penuh tidak dapat dimainkan buat sementara. Cuba muat semula atau gunakan Muat turun.",
    "retryAudio": "Cuba main semula",
    "audioOnly": "Kamera dimatikan / panggilan audio",
    "mute": "Senyapkan mikrofon",
    "unmute": "Hidupkan mikrofon",
    "cameraOff": "Matikan kamera",
    "cameraOn": "Hidupkan kamera",
    "devices": "Peranti audio dan video",
    "speakerOn": "Matikan pembesar suara",
    "speakerOff": "Hidupkan pembesar suara",
    "playAudio": "Mainkan audio",
    "retry": "Sambung semula",
    "audioinput": "Mikrofon",
    "videoinput": "Kamera",
    "audiooutput": "Pembesar suara",
    "selectDevice": "Pilih peranti",
    "connectionError": "Gagal menyambungkan panggilan. Semak rangkaian dan cuba lagi.",
    "secureContextError": "Camera and microphone require HTTPS. Open the doctor workspace over a secure HTTPS address.",
    "microphoneError": "Mikrofon tidak tersedia. Semak kebenaran pelayar atau pilih mikrofon lain.",
    "cameraError": "Kamera tidak tersedia. Panggilan audio boleh diteruskan.",
    "deviceError": "Gagal menukar atau memainkan peranti ini.",
    "download": "Muat turun audio",
    "status": {
      "ringing": "Berdering",
      "connecting": "Menyambung",
      "active": "Dalam panggilan",
      "reconnecting": "Menyambung semula",
      "ended": "Tamat",
      "cancelled": "Dibatalkan",
      "declined": "Ditolak",
      "missed": "Tidak dijawab"
    },
    "connection": {
      "connecting": "Menyambung",
      "connected": "Disambungkan",
      "reconnecting": "Menyambung semula",
      "disconnected": "Terputus",
      "signalReconnecting": "Menyambung semula"
    },
    "processing": {
      "none": "Belum bermula",
      "collecting": "Mengumpulkan audio",
      "transcribing": "Mentranskripsikan",
      "summarizing": "Meringkaskan",
      "ready": "Sedia diserahkan",
      "needs_note": "Nota doktor diperlukan",
      "failed": "Pemprosesan gagal"
    },
    "source": {
      "doctor": "Pihak doktor",
      "patient_terminal": "Pihak pesakit"
    },
    "measurementStatus": {
      "pending": "Menunggu",
      "starting": "Memulakan",
      "measuring": "Mengukur",
      "completed": "Selesai",
      "failed": "Gagal",
      "cancelled": "Dibatalkan",
      "stopped": "Dihentikan",
      "timeout": "Tamat masa"
    },
    "recordingStatus": {
      "recording": "Merakam",
      "ready": "Tersedia",
      "complete": "Tersedia",
      "completed": "Tersedia",
      "failed": "Rakaman gagal"
    }
  },
  "zh-HK": {
    "title": "即時問診",
    "call": "視訊問診",
    "available": "接受來電",
    "synced": "已連線",
    "reconnecting": "正在重新連線",
    "refresh": "重新整理",
    "incoming": "待接來電",
    "patients": "線上患者",
    "history": "歷史紀錄",
    "current": "目前通話",
    "noIncoming": "暫無來電",
    "noPatients": "暫無線上患者",
    "noHistory": "暫無歷史通話",
    "patient": "患者",
    "visit": "就診 {{id}}",
    "invite": "呼叫患者",
    "noSelection": "選擇來電或線上患者",
    "patientChart": "患者檔案",
    "incomingCall": "患者來電",
    "waitingPatient": "等待患者接聽",
    "accept": "接聽",
    "reject": "拒絕",
    "cancel": "取消",
    "end": "結束通話",
    "recordingAgreed": "已同意音訊錄製",
    "recordingNotAgreed": "未同意音訊錄製",
    "transcript": "通話轉錄",
    "noTranscript": "暫無轉錄內容",
    "transcriptHint": "每一行是通話時間軸上的一段辨識結果，可能短於完整錄音。",
    "recordings": "通話錄音",
    "combined": "完整通話",
    "combinedHint": "雙聲道錄音：醫生在左聲道，患者在右聲道。",
    "sourceRecordings": "原始錄音",
    "recordingsHint": "這裡顯示完整通話錄音；背景可能按短片段上載，以確保錄音穩定。",
    "recordingGapHint": "同一來源的分段之間有 {{duration}} 的時間空檔，通常表示錄音連線中斷或舊分段歸檔延遲；轉錄仍按通話時間軸顯示。",
    "recordingMissingSource": "未採集到 {{sources}} 的原始錄音。",
    "callTime": "通話時間",
    "callDuration": "通話時長",
    "durationUnavailable": "暫無",
    "segmentTimeUnavailable": "暫無分段時間",
    "segmentTimeline": "時間軸",
    "segmentDuration": "時長",
    "summary": "問診摘要",
    "measurements": "測量項目",
    "noMeasurements": "暫無可用測量項目",
    "startMeasurement": "開始測量",
    "stopMeasurement": "停止測量",
    "handoffNote": "醫師交接紀錄",
    "noteRequired": "錄音無法使用或內容不完整時，需要醫師補充交接紀錄後才能繼續 AI 問診。",
    "saveNote": "儲存紀錄",
    "returnAI": "交回 AI",
    "finishReport": "結束並產生待審核報告",
    "pendingReview": "通話摘要完成後，AI 將繼續問診或產生報告；報告仍需醫師審核。",
    "unavailable": "遠端問診服務暫時無法使用",
    "loadError": "無法載入問診詳情，請重新整理後重試。",
   "actionError": "操作未完成，請重新整理通話狀態後重試。",
    "audioLoading": "正在載入完整通話錄音...",
    "audioPlaybackError": "完整通話錄音暫時無法播放，請重新載入或使用下載。",
    "retryAudio": "重試播放",
    "audioOnly": "攝影機關閉 / 音訊通話",
    "mute": "關閉麥克風",
    "unmute": "開啟麥克風",
    "cameraOff": "關閉攝影機",
    "cameraOn": "開啟攝影機",
    "devices": "音訊與視訊設備",
    "speakerOn": "關閉揚聲器",
    "speakerOff": "開啟揚聲器",
    "playAudio": "播放音訊",
    "retry": "重新連線",
    "audioinput": "麥克風",
    "videoinput": "攝影機",
    "audiooutput": "喇叭",
    "selectDevice": "選擇設備",
    "connectionError": "無法連線通話，請檢查網路後重試。",
    "secureContextError": "摄像头和麦克风需要 HTTPS，请使用安全的 HTTPS 地址打开医生工作台。",
    "microphoneError": "麥克風無法使用，請檢查瀏覽器權限或選擇其他麥克風。",
    "cameraError": "攝影機無法使用，可以繼續音訊通話。",
    "deviceError": "無法切換或播放此設備。",
    "download": "下載音訊",
    "status": {
      "ringing": "響鈴中",
      "connecting": "連線中",
      "active": "通話中",
      "reconnecting": "重新連線中",
      "ended": "已結束",
      "cancelled": "已取消",
      "declined": "已拒絕",
      "missed": "未接聽"
    },
    "connection": {
      "connecting": "連線中",
      "connected": "已連線",
      "reconnecting": "重新連線中",
      "disconnected": "連線中斷",
      "signalReconnecting": "重新連線中"
    },
    "processing": {
      "none": "尚未開始",
      "collecting": "整理錄音中",
      "transcribing": "轉錄中",
      "summarizing": "摘要處理中",
      "ready": "交接就緒",
      "needs_note": "需要醫師補記",
      "failed": "處理失敗"
    },
    "source": {
      "doctor": "醫師",
      "patient_terminal": "患者"
    },
    "measurementStatus": {
      "pending": "等待測量",
      "starting": "正在啟動",
      "measuring": "測量中",
      "completed": "已完成",
      "failed": "失敗",
      "cancelled": "已取消",
      "stopped": "已停止",
      "timeout": "已逾時"
    },
    "recordingStatus": {
      "recording": "錄製中",
      "ready": "可播放",
      "complete": "可播放",
      "completed": "可播放",
      "failed": "錄音失敗"
    }
  },
  "zh-MO": {
    "title": "即時問診",
    "call": "視訊問診",
    "available": "接受來電",
    "synced": "已連線",
    "reconnecting": "正在重新連線",
    "refresh": "重新整理",
    "incoming": "待接來電",
    "patients": "線上患者",
    "history": "歷史紀錄",
    "current": "目前通話",
    "noIncoming": "暫無來電",
    "noPatients": "暫無線上患者",
    "noHistory": "暫無歷史通話",
    "patient": "患者",
    "visit": "就診 {{id}}",
    "invite": "呼叫患者",
    "noSelection": "選擇來電或線上患者",
    "patientChart": "患者檔案",
    "incomingCall": "患者來電",
    "waitingPatient": "等待患者接聽",
    "accept": "接聽",
    "reject": "拒絕",
    "cancel": "取消",
    "end": "結束通話",
    "recordingAgreed": "已同意音訊錄製",
    "recordingNotAgreed": "未同意音訊錄製",
    "transcript": "通話轉錄",
    "noTranscript": "暫無轉錄內容",
    "transcriptHint": "每一行是通話時間軸上的一段辨識結果，可能短於完整錄音。",
    "recordings": "通話錄音",
    "combined": "完整通話",
    "combinedHint": "雙聲道錄音：醫生在左聲道，患者在右聲道。",
    "sourceRecordings": "原始錄音",
    "recordingsHint": "這裡顯示完整通話錄音；背景可能按短片段上載，以確保錄音穩定。",
    "recordingGapHint": "同一來源的分段之間有 {{duration}} 的時間空檔，通常表示錄音連線中斷或舊分段歸檔延遲；轉錄仍按通話時間軸顯示。",
    "recordingMissingSource": "未採集到 {{sources}} 的原始錄音。",
    "callTime": "通話時間",
    "callDuration": "通話時長",
    "durationUnavailable": "暫無",
    "segmentTimeUnavailable": "暫無分段時間",
    "segmentTimeline": "時間軸",
    "segmentDuration": "時長",
    "summary": "問診摘要",
    "measurements": "測量項目",
    "noMeasurements": "暫無可用測量項目",
    "startMeasurement": "開始測量",
    "stopMeasurement": "停止測量",
    "handoffNote": "醫師交接紀錄",
    "noteRequired": "錄音無法使用或內容不完整時，需要醫師補充交接紀錄後才能繼續 AI 問診。",
    "saveNote": "儲存紀錄",
    "returnAI": "交回 AI",
    "finishReport": "結束並產生待審核報告",
    "pendingReview": "通話摘要完成後，AI 將繼續問診或產生報告；報告仍需醫師審核。",
    "unavailable": "遠端問診服務暫時無法使用",
    "loadError": "無法載入問診詳情，請重新整理後重試。",
   "actionError": "操作未完成，請重新整理通話狀態後重試。",
    "audioLoading": "正在載入完整通話錄音...",
    "audioPlaybackError": "完整通話錄音暫時無法播放，請重新載入或使用下載。",
    "retryAudio": "重試播放",
    "audioOnly": "攝影機關閉 / 音訊通話",
    "mute": "關閉麥克風",
    "unmute": "開啟麥克風",
    "cameraOff": "關閉攝影機",
    "cameraOn": "開啟攝影機",
    "devices": "音訊與視訊設備",
    "speakerOn": "關閉揚聲器",
    "speakerOff": "開啟揚聲器",
    "playAudio": "播放音訊",
    "retry": "重新連線",
    "audioinput": "麥克風",
    "videoinput": "攝影機",
    "audiooutput": "喇叭",
    "selectDevice": "選擇設備",
    "connectionError": "無法連線通話，請檢查網路後重試。",
    "secureContextError": "摄像头和麦克风需要 HTTPS，请使用安全的 HTTPS 地址打开医生工作台。",
    "microphoneError": "麥克風無法使用，請檢查瀏覽器權限或選擇其他麥克風。",
    "cameraError": "攝影機無法使用，可以繼續音訊通話。",
    "deviceError": "無法切換或播放此設備。",
    "download": "下載音訊",
    "status": {
      "ringing": "響鈴中",
      "connecting": "連線中",
      "active": "通話中",
      "reconnecting": "重新連線中",
      "ended": "已結束",
      "cancelled": "已取消",
      "declined": "已拒絕",
      "missed": "未接聽"
    },
    "connection": {
      "connecting": "連線中",
      "connected": "已連線",
      "reconnecting": "重新連線中",
      "disconnected": "連線中斷",
      "signalReconnecting": "重新連線中"
    },
    "processing": {
      "none": "尚未開始",
      "collecting": "整理錄音中",
      "transcribing": "轉錄中",
      "summarizing": "摘要處理中",
      "ready": "交接就緒",
      "needs_note": "需要醫師補記",
      "failed": "處理失敗"
    },
    "source": {
      "doctor": "醫師",
      "patient_terminal": "患者"
    },
    "measurementStatus": {
      "pending": "等待測量",
      "starting": "正在啟動",
      "measuring": "測量中",
      "completed": "已完成",
      "failed": "失敗",
      "cancelled": "已取消",
      "stopped": "已停止",
      "timeout": "已逾時"
    },
    "recordingStatus": {
      "recording": "錄製中",
      "ready": "可播放",
      "complete": "可播放",
      "completed": "可播放",
      "failed": "錄音失敗"
    }
  }
};

// Russian keeps the complete realtime consultation contract even when a new
// backend status key is added before its reviewed copy lands. The visible
// workflow labels below replace the most frequent English fallbacks.
realtimeConsultationTranslations['ru-RU'] = JSON.parse(
  JSON.stringify(realtimeConsultationTranslations['en-US'])
);
Object.assign(realtimeConsultationTranslations['ru-RU'], {
  title: 'Онлайн-консультации',
  call: 'Консультация',
  available: 'Приём звонков',
  synced: 'Подключено',
  reconnecting: 'Повторное подключение',
  refresh: 'Обновить',
  incoming: 'Входящие',
  patients: 'Пациенты онлайн',
  history: 'История',
  current: 'Текущий звонок',
  noIncoming: 'Нет входящих звонков',
  noPatients: 'Нет пациентов онлайн',
  patient: 'Пациент',
  invite: 'Позвонить пациенту',
  incomingCall: 'Пациент звонит',
  waitingPatient: 'Ожидание пациента',
  accept: 'Принять',
  reject: 'Отклонить',
  cancel: 'Отмена',
  end: 'Завершить звонок',
  transcript: 'Расшифровка звонка',
  summary: 'Итоги консультации',
  measurements: 'Измерения',
  startMeasurement: 'Начать измерение',
  stopMeasurement: 'Остановить измерение',
  handoffNote: 'Запись для передачи врачу',
  saveNote: 'Сохранить запись',
  returnAI: 'Вернуться к ИИ',
  finishReport: 'Завершить и подготовить отчёт',
});
Object.assign(realtimeConsultationTranslations['ru-RU'].status, {
  ringing: 'Звонок', connecting: 'Подключение', active: 'На связи',
  reconnecting: 'Повторное подключение', ended: 'Завершён',
  cancelled: 'Отменён', declined: 'Отклонён', missed: 'Пропущен',
});

Object.assign(realtimeConsultationTranslations['ru-RU'], {
  "title": "Текущие консультации",
  "call": "Звонок консультации",
  "available": "Принимает вызовы",
  "synced": "Подключено",
  "reconnecting": "Переподключение",
  "refresh": "Обновить",
  "incoming": "Входящие",
  "patients": "Пациенты онлайн",
  "history": "История",
  "current": "Текущий вызов",
  "noIncoming": "Нет входящих вызовов",
  "noPatients": "Нет пациентов онлайн",
  "noHistory": "Нет предыдущих вызовов",
  "patient": "Пациент",
  "visit": "Визит {{id}}",
  "invite": "Вызвать пациента",
  "noSelection": "Выберите звонок или пациента онлайн",
  "patientChart": "Медицинская карта пациента",
  "incomingCall": "Пациент звонит",
  "waitingPatient": "Ожидание пациента",
  "accept": "Принять",
  "reject": "Отклонить",
  "cancel": "Отмена",
  "end": "Завершить звонок",
  "recordingAgreed": "Запись аудио разрешена",
  "recordingNotAgreed": "Аудиозапись не разрешена",
  "transcript": "Транскрипция вызова",
  "noTranscript": "Транскрипция пока отсутствует",
  "transcriptHint": "Каждая строка представляет собой один распознанный речевой интервал на временной шкале вызова; он может быть короче полной записи.",
  "recordings": "Запись вызова",
  "combined": "Завершить вызов",
  "combinedHint": "Стереозапись: врач на левом канале, пациент на правом.",
  "sourceRecordings": "Исходные записи",
  "recordingsHint": "Это полная запись вызова. Короткие фрагменты источника могут загружаться в фоновом режиме для обеспечения надежности захвата.",
  "recordingGapHint": "Между сегментами из одного источника обнаружен промежуток {{duration}}. Обычно это означает прерывание аудиосоединения или позднее завершение предыдущего сегмента; время транскрипции остается на временной шкале вызова.",
  "recordingMissingSource": "Аудио из источника {{sources}} не было захвачено.",
  "callTime": "Время вызова",
  "callDuration": "Длительность вызова",
  "durationUnavailable": "Недоступно",
  "segmentTimeUnavailable": "Время сегмента недоступно",
  "segmentTimeline": "Хронология",
  "segmentDuration": "Длительность",
  "summary": "Сводка консультации",
  "measurements": "Измерения",
  "noMeasurements": "Функции измерения недоступны",
  "startMeasurement": "Начать измерение",
  "stopMeasurement": "Остановить измерение",
  "handoffNote": "Заметка врача при передаче пациента",
  "noteRequired": "Требуется заметка врача, чтобы ИИ мог продолжить работу, если запись недоступна или неполна.",
  "saveNote": "Сохранить заметку",
  "returnAI": "Вернуться к ИИ",
  "finishReport": "Завершить и подготовить отчет",
  "pendingReview": "Звонок будет резюмирован перед тем, как ИИ продолжит работу или подготовит отчет. Отчеты все равно требуют проверки врачом.",
  "unavailable": "Сервис удаленной консультации недоступен",
  "loadError": "Не удалось загрузить данные консультации. Обновите страницу и попробуйте снова.",
  "actionError": "Действие не выполнено. Обновите статус вызова и попробуйте снова.",
  "audioLoading": "Загрузка полной записи звонка...",
  "audioPlaybackError": "Полная запись звонка временно недоступна. Попробуйте загрузить её снова или используйте скачивание.",
  "retryAudio": "Повторить воспроизведение",
  "audioOnly": "Камера выключена / аудиовызов",
  "mute": "Отключить микрофон",
  "unmute": "Включить микрофон",
  "cameraOff": "Выключить камеру",
  "cameraOn": "Включить камеру",
  "devices": "Аудио- и видеоустройства",
  "speakerOn": "Выключить динамик",
  "speakerOff": "Включить динамик",
  "playAudio": "Воспроизвести аудио",
  "retry": "Переподключиться",
  "audioinput": "Микрофон",
  "videoinput": "Камера",
  "audiooutput": "Динамик",
  "selectDevice": "Выбрать устройство",
  "connectionError": "Не удалось подключиться к звонку. Проверьте сеть и переподключитесь.",
  "secureContextError": "Для работы камеры и микрофона требуется HTTPS. Откройте рабочее место врача по защищенному адресу HTTPS.",
  "microphoneError": "Микрофон недоступен. Проверьте разрешения браузера или выберите другой микрофон.",
  "cameraError": "Камера недоступна. Аудиозвонок может продолжаться.",
  "deviceError": "Не удалось переключить или воспроизвести это устройство.",
  "download": "Скачать аудио",
  "status": {
    "ringing": "Звонит",
    "connecting": "Подключение",
    "active": "В звонке",
    "reconnecting": "Переподключение",
    "ended": "Завершено",
    "cancelled": "Отменено",
    "declined": "Отклонено",
    "missed": "Пропущено"
  },
  "connection": {
    "connecting": "Подключение",
    "connected": "Подключено",
    "reconnecting": "Переподключение",
    "disconnected": "Отключено",
    "signalReconnecting": "Переподключение"
  },
  "processing": {
    "none": "Не начато",
    "collecting": "Сбор аудио",
    "transcribing": "Транскрибация",
    "summarizing": "Суммаризация",
    "ready": "Готовность к передаче",
    "needs_note": "Требуется заключение врача",
    "failed": "Ошибка обработки"
  },
  "source": {
    "doctor": "Врач",
    "patient_terminal": "Пациент"
  },
  "measurementStatus": {
    "pending": "В ожидании",
    "starting": "Запуск",
    "measuring": "Измерение",
    "completed": "Завершено",
    "failed": "Не удалось",
    "cancelled": "Отменено",
    "stopped": "Остановлено",
    "timeout": "Время ожидания истекло"
  },
  "recordingStatus": {
    "recording": "Запись",
    "ready": "Доступно",
    "complete": "Доступно",
    "completed": "Доступно",
    "failed": "Ошибка записи"
  }
});

export default realtimeConsultationTranslations;
